import { API } from 'aws-amplify';

// @ts-ignore
export const create = (one) => API.put('ihrespezialistenBackend', '/ads', { body: one });

// @ts-ignore
export const read = () => API.get('ihrespezialistenBackend', '/ads', {});

// @ts-ignore
export const readOne = (id) => API.get('ihrespezialistenBackend', `/ads/${id}`, {});

// @ts-ignore
export const update = (one) => API.post('ihrespezialistenBackend', `/ads/${one.id}`, { body: one });

// @ts-ignore
export const remove = (id) => API.del('ihrespezialistenBackend', `/ads/${id}`, {});
